import { setIsTarjous } from "./keikka/KeikkaFunctions";

export default class keikkaModulesClass {
  constructor(keikkaId) {
    this.keikkaId = keikkaId;
    this.pumppu = true; // hasPumppu
    this.betoni = true; // hasBetoni
    this.lattia = false; // hasLattia
    this.toimitus = false; // hasToimitus
  }

  isTarjous(stepLog) {
    return stepLog.isTarjouspyyntö;
  }
  get hasPumppu() {
    return this.pumppu;
  }
  set hasPumppu(_pumppu) {
    this.pumppu = _pumppu;
  }
  get hasBetoni() {
    return this.betoni;
  }
  set hasBetoni(_betoni) {
    this.betoni = _betoni;
  }
  get hasLattia() {
    return this.lattia;
  }
  set hasLattia(_lattia) {
    this.lattia = _lattia;
  }
  get hasToimitus() {
    return this.toimitus;
  }
  set hasToimitus(_toimitus) {
    this.toimitus = _toimitus;
  }

  saveModulesToDB(token) {
    const url = "/api/keikka/saveModulesToDB";
    const fetchResponse = fetch(import.meta.env.VITE_SERVER_URL + url, {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaId: this.keikkaId,
        hasPumppu: this.hasPumppu,
        hasBetoni: this.hasBetoni,
        hasLattia: this.hasLattia,
        hasToimitus: this.hasToimitus,
      }),
    });
    return fetchResponse.ok === true;
  }

  setTarjous(keikkaData, person, _tarjous, socket) {
    setIsTarjous(keikkaData, person, _tarjous, socket);
  }

  get hash() {
    const p = this.hasPumppu ? 1 : 2;
    const b = this.hasBetoni ? 4 : 8;
    const l = this.hasLattia ? 16 : 32;
    const t = this.hasToimitus ? 64 : 128;
    //const q = this.isTarjous ? 256 : 512; this might slow the hash calculation a lot
    return p + b + l + t;
  }
}
